import CIMSTable from 'components/CIMSTable'
import { useSubtypesTableContext } from '../../SubtypesTableContext'
import { useColumns } from './hooks/useColumns'
import { useCreateOptions } from './hooks/useCreateOptions'
import { useEditOptions } from './hooks/useEditOptions'
import { useExpandOptions } from './hooks/useExpandOptions'
import { useRemoveOptions } from './hooks/useRemoveOptions'
import { useRestoreOptions } from './hooks/useRestoreOptions'

export const SubtypesTable: React.FC = () => {
  const { records, refetch: onReload, fetching } = useSubtypesTableContext()

  return (
    <CIMSTable
      rowKey={'id'}
      records={records}
      columns={useColumns()}
      loading={fetching}
      actions={{
        header: { create: useCreateOptions(), onReload },
        row: {
          remove: useRemoveOptions(),
          edit: useEditOptions(),
          restore: useRestoreOptions(),
        },
      }}
      expand={useExpandOptions()}
    />
  )
}
